import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { Icon } from "../components/Icon";
import { Label } from "../components/Label";
import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import * as React from "react";
export const radioStyles = cva(cn("h-5 w-5 aspect-square rounded-full border transition duration-100 ease-out motion-reduce:transition-none active:scale-95", "border-border-dark", "bg-background", "text-foreground", "flex items-center justify-center", "focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-ring", "checked:ring-0"));
export const radioIndicatorStyles = cva(cn("h-3 w-3 bg-primary flex items-center justify-center rounded-full", 
// Quick pop-in on select; deselecting unmounts instantly, which is fine —
// exits may be faster than entrances, and this is a high-frequency control.
"animate-in fade-in-0 zoom-in-90 duration-150 ease-enter motion-reduce:animate-none"));
const RadioGroup = React.forwardRef(({ className, ...props }, ref) => {
    return (React.createElement(RadioGroupPrimitive.Root, { className: cn("grid gap-2", className), ...props, ref: ref }));
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;
const RadioGroupItem = React.forwardRef(({ className, icon, label, id, ...props }, ref) => {
    const renderIcon = (visual, extraClass = "") => (React.createElement(Icon, { visual: visual, size: "sm", className: cn("text-foreground", extraClass) }));
    const item = (React.createElement(RadioGroupPrimitive.Item, { ref: ref, id: id, className: cn(radioStyles(), className), ...props },
        React.createElement(RadioGroupPrimitive.Indicator, { className: radioIndicatorStyles() })));
    const wrappedItem = (React.createElement("div", { className: "flex w-full items-center gap-2" },
        item,
        icon && renderIcon(icon),
        React.createElement(Label, { htmlFor: id, className: cn("cursor-pointer", props.disabled && "cursor-not-allowed opacity-70") }, label)));
    return React.createElement("div", { className: "group w-full" }, wrappedItem);
});
const RadioGroupCustomItem = React.forwardRef(({ className, customItem, iconPosition = "center", children, id, ...props }, ref) => {
    const item = (React.createElement(RadioGroupPrimitive.Item, { ref: ref, id: id, className: cn(radioStyles(), className), ...props },
        React.createElement(RadioGroupPrimitive.Indicator, { className: radioIndicatorStyles() })));
    return (React.createElement("div", { className: cn("flex w-full flex-col", props.disabled && "opacity-70 [&_label]:cursor-not-allowed", className, `items-${iconPosition}`) },
        React.createElement("div", { className: "flex w-full items-center gap-2" },
            item,
            customItem),
        children));
});
export { RadioGroup, RadioGroupCustomItem, RadioGroupItem };
//# sourceMappingURL=RadioGroup.js.map